import {Form} from 'antd';
import {useCallback} from 'react';

import {Locale} from '../../../../../../../../provider/locale/localization';
import {useSnackbar} from '../../../../../../../../provider/snackbar/snackbar-hook';
import {useFormRules} from '../../../../../../../../service/form/form-rules-hook';
import {saveGeneratedImage} from '../../../../../../../../service/posts/posts-api';
import {
    PostAiSuggestApplyType,
    PostAiSuggestHookType,
    PostFormFieldsEnum,
    PostFormType,
} from '../../../../../../../../service/posts/posts-types';

import {PostAiSuggest} from './ai-suggest/post-ai-suggest';
import {PostTextField} from './post-text-field';

type PropsType = {
    onChange: (newCommonText: string) => void;
    value: string;
    maxLength: number;
    suggestSettings: PostAiSuggestHookType;
    onApplyImageUrl: (url: string) => void;
};

export function CommonTextItem(props: PropsType): JSX.Element {
    const {maxLength, onChange, value, suggestSettings, onApplyImageUrl} = props;

    const {maxLengthFieldRule} = useFormRules();
    const {snackbar} = useSnackbar();

    const handleApplySuggest = useCallback(
        async (apply: PostAiSuggestApplyType) => {
            if (apply.image) {
                try {
                    // save-on-select: copies the temporary preview into permanent post storage
                    const response = await saveGeneratedImage(apply.image.url);

                    onApplyImageUrl(response.image);
                } catch {
                    // preview may be expired (410) or service failed: continue with text only
                    snackbar.error({
                        message: <Locale stringKey="POSTS_AI_GENERATION__ERROR__IMAGE_TITLE" />,
                        description: <Locale stringKey="POSTS_SUGGESTS_ERROR__CONTENT" />,
                    });
                }
            }

            // call to action is not applicable on the common content step
            onChange(apply.text);
        },
        [onApplyImageUrl, onChange, snackbar]
    );

    return (
        <Form.Item<PostFormType>
            dependencies={[PostFormFieldsEnum.Posts]}
            label={<Locale stringKey="POSTS_FORM__CONTENT__LABEL" />}
            rules={[maxLengthFieldRule(maxLength)]}
        >
            {() => (
                <>
                    <PostTextField disabled={false} maxLength={maxLength} onChange={onChange} value={value} />
                    <PostAiSuggest onApplySuggest={handleApplySuggest} suggestSettings={suggestSettings} />
                </>
            )}
        </Form.Item>
    );
}
